//LOGIN
export const POST_LOGIN = "/auth/login";
